// Import Swiper React components
import { Scrollbar, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import khuluq from "../../imgs/khuluqadheem.png";
import warith from "../../imgs/warithanbia.png";
import marks from "../../imgs/students-marks-system.png";
import attendance from "../../imgs/attendance.png";
import islah from "../../imgs/islah.png";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';


export default function Slider(){
    const data = [
        {
            id: 0,
            name: "مؤسسة الخلق العظيم",
            image: khuluq,
            link: "https://www.khuluqadheem.com"
        },
        {
            id: 1,
            name: "مؤسسة وارث الأنبياء",
            image: warith,
            link: "https://www.warithanbia.com"
        },
        {
            id: 2,
            name: "نظام حساب درجات الطلاب",
            image: marks,
            link: "",
        },
        {
            id: 3,
            name: "نظام إدارة الحضور والغياب",
            image: attendance,
            link: ""
        },
        {
            id: 4,
            name: "مجلة الإصلاح الحسيني",
            image: islah,
            link: "https://islahhuseini.warithanbia.com/"
        },
    ];

    return(
    <Swiper
        modules={[Scrollbar, Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={50}
        slidesPerView={1}
        scrollbar={{ draggable: true }}
    >
        {data?.map(item => (
            <SwiperSlide key={item.id} className="slide position-relative">
                <p className="slideTitle">{item.name}</p>
                <a 
                    href={item.link} 
                    target="blank"
                >
                    <img 
                        className="rounded" 
                        src={item.image} 
                        alt={item.name} 
                    />
                </a>
            </SwiperSlide>
        ))}

    </Swiper>
    )
}